<template>
  <card class="w-100">
    <el-row :gutter="10">
      <el-col :span="4">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  ref="mediaTable"
                  :data="medias"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            prop="media_name"
            label="매체명">
          </el-table-column>
          <el-table-column
            label="설정">
            <template slot-scope="scope">
              <el-switch :id="'MEDIA:' + scope.row.media_info_seq"
                         :value="'MEDIA:' + scope.row.media_info_seq + ':' + scope.row.auth" @change="switchChange"
                         :active-value="'MEDIA:' + scope.row.media_info_seq + ':1'"
                         :inactive-value="'MEDIA:' + scope.row.media_info_seq  + ':0'"></el-switch>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="4">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  ref="profitTable"
                  :data="profit"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            prop="name"
            label="수익구분">
          </el-table-column>
          <el-table-column
            label="설정">
            <template slot-scope="scope">
              <el-switch :id="'PROFIT:' + scope.row.code"
                         :value="'PROFIT:' + scope.row.code + ':' + scope.row.auth" @change="switchChange"
                         :active-value="'PROFIT:' + scope.row.code + ':1'"
                         :inactive-value="'PROFIT:' + scope.row.code  + ':0'"></el-switch>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="4">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  ref="inOutTable"
                  :data="inOut"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            prop="name"
            label="IN/OUT">
          </el-table-column>
          <el-table-column
            label="설정">
            <template slot-scope="scope">
              <el-switch :id="'IN_OUT:' + scope.row.code"
                         :value="'IN_OUT:' + scope.row.code + ':' + scope.row.auth" @change="switchChange"
                         :active-value="'IN_OUT:' + scope.row.code + ':1'"
                         :inactive-value="'IN_OUT:' + scope.row.code  + ':0'"></el-switch>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="4">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  ref="lightTable"
                  :data="light"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            prop="name"
            label="조명여부">
          </el-table-column>
          <el-table-column
            label="설정">
            <template slot-scope="scope">
              <el-switch :id="'LIGHT:' + scope.row.code"
                         :value="'LIGHT:' + scope.row.code + ':' + scope.row.auth" @change="switchChange"
                         :active-value="'LIGHT:' + scope.row.code + ':1'"
                         :inactive-value="'LIGHT:' + scope.row.code  + ':0'"></el-switch>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="4">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  ref="storeStatusTable"
                  :data="storeStatus"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            prop="name"
            label="점포현황">
          </el-table-column>
          <el-table-column
            label="설정">
            <template slot-scope="scope">
              <el-switch :id="'STORE_STATUS:' + scope.row.code"
                         :value="'STORE_STATUS:' + scope.row.code + ':' + scope.row.auth" @change="switchChange"
                         :active-value="'STORE_STATUS:' + scope.row.code + ':1'"
                         :inactive-value="'STORE_STATUS:' + scope.row.code  + ':0'"></el-switch>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="4">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  ref="advertisement"
                  :data="advertisement"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            prop="name"
            label="광고주현황">
          </el-table-column>
          <el-table-column
            label="설정">
            <template slot-scope="scope">
              <el-switch :id="'ADVERTISEMENT:' + scope.row.code"
                         :value="'ADVERTISEMENT:' + scope.row.code + ':' + scope.row.auth" @change="switchChange"
                         :active-value="'ADVERTISEMENT:' + scope.row.code + ':1'"
                         :inactive-value="'ADVERTISEMENT:' + scope.row.code  + ':0'"></el-switch>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="card-footer text-right">
      <el-button @click.prevent="historyBack">권한관리로 가기</el-button>
    </div>
  </card>
</template>

<script>
  import Vue from 'vue'
  import {Table, TableColumn, Row, Col, Switch, Button} from 'element-ui'
  import AuthorityProxy from "../../../../proxies/AuthorityProxy";

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Row)
  Vue.use(Col)
  Vue.use(Switch)
  Vue.use(Button)

  export default {
    name: "SettingsRoleAuth",
    created: function () {
      this.roleCode = this.$route.params.roleCode;
      this.$store.dispatch('common/setMenuTitle', Vue.getRoleName(this.roleCode) + " 권한설정");
      this.getRoleAuth("MEDIA");
      this.getRoleAuth("PROFIT");
      this.getRoleAuth("IN_OUT");
      this.getRoleAuth("LIGHT");
      this.getRoleAuth("STORE_STATUS");
      this.getRoleAuth("ADVERTISEMENT");
    },
    updated: function () {
      this.$refs.mediaTable.doLayout();
      this.$refs.profitTable.doLayout();
      this.$refs.inOutTable.doLayout();
      this.$refs.lightTable.doLayout();
      this.$refs.storeStatusTable.doLayout();
      this.$refs.advertisement.doLayout();
    },
    methods: {
      tableRowStyle() {
        return this.$store.state.common.tableHeaderCellStyle;
      },
      historyBack() {
        history.back();
      },
      getRoleAuth(authType) {
        new AuthorityProxy()
          .getRoleAuth(this.roleCode, authType)
          .then((response) => {
            switch (authType) {
              case "MEDIA":
                this.medias = response.roleAuth;
                break;
              case "PROFIT":
                this.switchSet(response.roleAuth, this.profit);
                break;
              case "IN_OUT":
                this.switchSet(response.roleAuth, this.inOut);
                break;
              case "LIGHT":
                this.switchSet(response.roleAuth, this.light);
                break;
              case "STORE_STATUS":
                this.switchSet(response.roleAuth, this.storeStatus);
                break;
              case "ADVERTISEMENT":
                this.switchSet(response.roleAuth, this.advertisement);
                break;
            }
          });
      },
      switchChange(value) {
        let values = value.split(":");
        if (values[2] === "1") {
          let param = {
            roleCode: this.roleCode,
            authType: values[0],
            authValue: values[1],
          };
          new AuthorityProxy()
          .createRoleAuth(param)
            .then((response) => {
              this.getRoleAuth(values[0]);
            });
        } else {
          new AuthorityProxy()
          .deleteRoleAuth(this.roleCode, values[0], values[1])
            .then((response) => {
              this.getRoleAuth(values[0]);
            });
        }
      },
      switchSet(roleAuth, target) {
        target.forEach(function(item){
          if(roleAuth.filter(function (role) {
            return role.auth_value === this.code
          }, {code : item.code}).length > 0) {
            item.auth = 1;
          } else {
            item.auth = 0;
          }
        });
      },
    },
    data() {
      return {
        roleCode: '',
        medias: [],
        profit: [
          {
            code : "INCOMING",
            name : "수익",
            auth : 0
          },
          {
            code : "PL",
            name : "PL",
            auth : 0
          },
          {
            code : "EMPTY",
            name : "공실",
            auth : 0
          },
          {
            code : "AFFILIZATION",
            name : "제휴",
            auth : 0
          },
          {
            code : "ETC",
            name : "기타",
            auth : 0
          },
        ],
        inOut: [
          {
            code : "IN",
            name : "IN",
            auth : 0
          },
          {
            code : "OUT",
            name : "OUT",
            auth : 0
          },
        ],
        light: [
          {
            code : "1",
            name : "조명",
            auth : 0
          },
          {
            code : "0",
            name : "비조명",
            auth : 0
          },
        ],
        storeStatus: [
          {
            code : "LIST",
            name : "목록조회",
            auth : 0
          },
        ],
        advertisement: [
          {
            code : "LIST",
            name : "목록조회",
            auth : 0
          },
        ]

      }
    }
  }
</script>

<style scoped>

</style>
